import { request } from "@/api/client";
import { api } from "@/lib/api";
import type { ArtistSettings, ArtistSettingsPayload } from "@/types/artistSettings";

export function fetchMyArtist() {
  return request<ArtistSettings>("/artists/me");
}

export function updateMyArtist(payload: ArtistSettingsPayload) {
  return request<ArtistSettings>("/artists/me", {
    method: "PATCH",
    body: payload,
  });
}

export function uploadArtistBandPhoto(file: File) {
  const formData = new FormData();
  formData.append("file", file);
  return api.upload<ArtistSettings>("/artists/me/band-photo", formData);
}

export function uploadArtistLogo(file: File) {
  const formData = new FormData();
  formData.append("file", file);
  return api.upload<ArtistSettings>("/artists/me/logo", formData);
}
